import { AG_GRID_LOCALE_EN } from './en';
import { AG_GRID_LOCALE_ES } from './es';
import { AG_GRID_LOCALE_PT } from './pt';

const AG_GRID_LOCALE = {
  en: AG_GRID_LOCALE_EN,
  es: AG_GRID_LOCALE_ES,
  pt: AG_GRID_LOCALE_PT
};

export default AG_GRID_LOCALE;
